import { MessageQuestionMark } from 'components/icons/customIcons';
import { Sizes } from 'components/forms/NumberSelector';
import RadioButtonChoice from 'components/domain/ProfilingForm/RadioButtonChoice';
import React from 'react';
import { PossibleAnswer, Question } from '../../types/interfaces';
import { isBooleanAnswer } from '../../types/possibleAnswer';

interface SimpleBooleanQuestionProps {
  question: Question;
  currentAnswers: PossibleAnswer[];
  onAnswer: (key: string, answer: PossibleAnswer[]) => void;
  trueLabel?: string;
  falseLabel?: string;
}

const SimpleBooleanQuestion: React.FC<SimpleBooleanQuestionProps> = ({
  question,
  currentAnswers,
  onAnswer,
  trueLabel = "Oui",
  falseLabel = "Non"
}) => {
  const isBooleanSelected = (value: boolean): boolean => {
    if (!currentAnswers || currentAnswers.length === 0) return false;
    return currentAnswers.some(answer =>
      isBooleanAnswer(answer) && answer === value
    );
  };

  const handleBooleanAnswer = (value: boolean) => {
    onAnswer(question.key, [value]);
  };

  return (
    <div className="flex items-center justify-between w-full">
      <p className="flex gap-4 text-base text-zinc-800 flex-1">
        <MessageQuestionMark className='text-primary w-6'/>
        {question.label}
      </p>

      <div className="flex gap-2 ml-4">
        <RadioButtonChoice
          key={`${question.key}-true`}
          size={Sizes.sm}
          radio
          text={trueLabel}
          selected={isBooleanSelected(true)}
          handleOnClick={() => handleBooleanAnswer(true)}
        />
        <RadioButtonChoice
          key={`${question.key}-false`}
          size={Sizes.sm}
          radio
          text={falseLabel}
          selected={isBooleanSelected(false)}
          handleOnClick={() => handleBooleanAnswer(false)}
        />
      </div>
    </div>
  );
};

export default SimpleBooleanQuestion;
